export default __webpack_public_path__ + "static/media/z040mi0c.72eba2d8.mp3";